/**
 * @module store/slides/mutations
 *
 * @version 1.0.2
 * @copyright SBC 2019
 */


import * as types from '@/store/mutation-types';

/* eslint-disable no-param-reassign */
export default {
  /**
   * Mutation: Начало загрузки слайдов
   *
   * @since Version 1.0.2
   */
  [types.GET_SLIDES_ASYNC.PENDING](state) {
    state.isSlidesLoading = true;
  },


  /**
   * Mutation: Ошибка при загрузке слайдов
   *
   * @since Version 1.0.2
   */
  [types.GET_SLIDES_ASYNC.FAILURE](state) {
    state.isSlidesLoading = false;
  },


  /**
   * Mutation: Успешная загрзка слайдов
   *
   * @since Version 1.0.2
   */
  [types.GET_SLIDES_ASYNC.SUCCESS](state, data) {
    state.slides = data;
    state.isSlidesLoading = false;
  },


  /**
   * Mutation: Обновление слайда
   *
   * @since Version 1.0.2
   */
  changeSlide(state, slide) {
    // eslint-disable-next-line
    let index = state.slides.findIndex(e => e._id === slide._id);

    state.slides.splice(index, 1, slide);
  },
};
/* eslint-enable no-param-reassign */
